'use strict';

const siteFunctions = (function($) {

    const toggleChildren = () => {
		document.querySelectorAll("#header-menu .menu-item-has-children").forEach(function(item) {
            item.addEventListener("click", function(e) {
                if(e.target === e.currentTarget){
                    e.preventDefault();
                    item.classList.toggle("active");
                }
            });
        });
	};

    const toggleMenu = () => {
        window.onkeydown = function( event ) {
            if ( event.keyCode === 27 ) {
                document.querySelector("body").classList.remove("menu-open");
            }
        };
        document.querySelector("#main-header .bars").addEventListener("click", function(e) {
            e.preventDefault();
            document.querySelector("body").classList.toggle("menu-open");
        });
    };
	
	

	let publicFunctions = {};
	publicFunctions.init = function(options) {
        toggleMenu();
        toggleChildren();

		// When clicking on the "hamburger" icon in the header
		$(".hamburger").click(function(){
			let mobileMenu = $("#mobile-menu").toggleClass("open");
			$(this).toggleClass("is-active");
			$(".site-header").toggleClass("menu-collapsed");
			$(".site-header--menu").toggleClass("collapsed");
			closeHoverDropdownMenu();
		});
		
		$(".menu-item").click(function(){
			$('.hamburger').removeClass("is-active");
			$(".site-header").removeClass("menu-collapsed");
			$(".site-header--menu").removeClass("collapsed");
			closeHoverDropdownMenu();
		});
	};

	return publicFunctions;
})(jQuery);

jQuery(document).ready(function(){
	siteFunctions.init();
});

// Scroll reveal animations for blocks
document.addEventListener("DOMContentLoaded", () => {
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (!reducedMotion && "IntersectionObserver" in window) {
		document.documentElement.classList.add("js-anim");

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add("is-visible");
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
		);

		document.querySelectorAll(".block").forEach((block) => observer.observe(block));
	}
});

document.addEventListener("DOMContentLoaded", () => {
	// Slugify function to match PHP's sanitize_title()
	const slugify = (text) => {
		return text
			.toString()
			.normalize("NFD") // Normalize accents
			.replace(/[\u0300-\u036f]/g, "") // Remove diacritics
			.toLowerCase()
			.replace(/[^\w\s-]/g, "") // Remove non-word chars
			.replace(/\s+/g, "-") // Replace spaces with dashes
			.replace(/--+/g, "-") // Collapse multiple dashes
			.replace(/^-+|-+$/g, ""); // Trim leading/trailing dashes
	};

	document.querySelectorAll(".toc__item a").forEach((link) => {
		link.addEventListener("click", function (e) {
			e.preventDefault();
			const targetSlug = this.getAttribute("data-heading");
			const headings = document.querySelectorAll("h2, h3");

			for (let heading of headings) {
				const headingSlug = slugify(heading.textContent);
				if (headingSlug === targetSlug) {
					window.scrollTo({
						top: heading.offsetTop - 120,
						behavior: "smooth",
					});
					break;
				}
			}
		});
	});

    document.querySelectorAll('.faq-question').forEach(function (btn) {
		btn.addEventListener('click', function () {
			const item = this.closest('.faq-item');
			item.classList.toggle('open');
		});
	});

    const copyMarkdownBtn = document.querySelector(".copy-markdown-btn");
    const openMarkdownBtn = document.querySelector(".open-markdown-btn");
    if (!copyMarkdownBtn || !openMarkdownBtn) return;

    copyMarkdownBtn.addEventListener("click", async () => {
        const url = copyMarkdownBtn.dataset.markdownUrl; 

        try {
            const response = await fetch(url);
            const text = await response.text();

            setTimeout(() => {
                navigator.clipboard.writeText(text);
            }, 100)
        } catch (e) {
            console.error("Copy failed:", e);
        }
    });

    openMarkdownBtn.addEventListener("click", () => {
        const url = copyMarkdownBtn.dataset.markdownUrl;

        window.open(url, '_blank').focus();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gfield input, .gfield textarea').forEach(input => {
        const field = input.closest('.gfield');

        input.addEventListener('focus', () => {
            field.classList.add('gfield__focused');
        });

        input.addEventListener('blur', () => {
            if (input.value.trim() === '') {
                field.classList.remove('gfield__focused');
            }
        });

        if (input.value.trim() !== '') {
            field.classList.add('gfield__focused');
        }
    });
});


